const formats = {
    hh_mm_a: 'h:mm A',
    hh_mm_ss_a: 'h:mm:ss A',
    MMM_DD_hh_mm_a: 'MMM D, h:mm A',
    MMM_DD_YYYY_hh_mm_a: 'MMM D, YYYY h:mm A',
    logTs: 'MMM D, HH:mm:ss',
    logTs_date: 'MMM DD',
    logTs_time: 'HH:mm:ss',
    logTs_ms: '.SSS',
    MM_DD_YYYY_hh_mm_a: 'MM/DD/YYYY, h:mm A',
    MM_DD_YY_hh_mm_a: 'MM/DD/YY, h:mm A',
    server_date: 'YYYY-MM-DDD',
    MM_DD_YYYY_hh_mm_a_for_support: 'YYYY.MM.DD. h:mm A',
    paymentDate: 'MMM DD, YYYY',
};

export default formats;
